export enum StatCategory {
    Sessions = 'sessions',
    Duration = 'duration',
    Distance = 'distance',
    Calories = 'calories',
    AverageForce = 'average force',
    AverageStrokeRate = 'average stroke rate',
}
